/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandNexo = createReactComponent("brand-nexo", "IconBrandNexo", [
  ["path", { d: "M17 3l5 3v12l-5 3l-10 -6v-6l10 6v-6l-5 -3z", key: "svg-0" }],
  ["path", { d: "M12 6l-5 -3l-5 3v12l5 3l4.7 -3.13", key: "svg-1" }]
]);

export { IconBrandNexo as default };
//# sourceMappingURL=IconBrandNexo.js.map
